export const USER_STATUSES = {
  REVIEW: 'review',
  DECLINED: 'declined',
  APPROVED: 'approved',
  REQUESTED_TO_REMOVE: 'requested_to_remove',
  REMOVED: 'removed',
  BLOCKED: 'blocked',
};
